import React__default from 'react';

var MobileFooterColumn = function (_a) {
    var children = _a.children, position = _a.position;
    return React__default.createElement("div", { className: "pgc-".concat(position, "-m-footer") }, children);
};

export { MobileFooterColumn };
